import {Platform} from 'react-native';
// import TrackPlayer, {
//   AppKilledPlaybackBehavior,
//   Event,
//   PlaybackState,
//   RepeatMode,
//   State,
//   Track,
// } from 'react-native-track-player';
import {store} from '../../redux/store';
import {sleep} from '../helpers';

/** Check if we're on web */
const isWeb = Platform.OS === 'web';

/** A single <audio> element to mimic track loading/playback on web. */
let webAudio: HTMLAudioElement | null = null;

/**
 * "PlaybackService" for iOS/Android uses react-native-track-player events.
 * On Web, we can't do background or remote events, so we do nothing or minimal event setup.
 */
export const PlaybackService = async function () {
  if (isWeb) {
    // No background/remote events. Possibly handle onended here if you want.
    return;
  }
  // ----- Native (Android/iOS) setup -----
  // TrackPlayer.addEventListener(Event.PlaybackQueueEnded, () => {
  //   TrackPlayer.stop();
  //   TrackPlayer.seekTo(0);
  // });
  //
  // // Repeat single track
  // TrackPlayer.setRepeatMode(RepeatMode.Track);
  //
  // // Remote controls
  // TrackPlayer.addEventListener(Event.RemotePlay, () => TrackPlayer.play());
  // TrackPlayer.addEventListener(Event.RemotePause, () => TrackPlayer.pause());
  //
  // // Listen to progress
  // TrackPlayer.addEventListener(
  //   Event.PlaybackProgressUpdated,
  //   (progress: any) => {
  //     if (__DEV__) {
  //     }
  //   },
  // );
  //
  // // App-killed behavior
  // TrackPlayer.updateOptions({
  //   android: {
  //     appKilledPlaybackBehavior:
  //       AppKilledPlaybackBehavior.StopPlaybackAndRemoveNotification,
  //   },
  // });
};

/**
 * Attempt to load a sound (URL) up to `retries` times.
 * On native, uses TrackPlayer.add(...).
 * On web, sets `webAudio.src` and tries to load it.
 */
export const loadSound = async (
  url: string,
  retries: number = 3,
): Promise<boolean> => {
  if (!url) {
    return false;
  }

  if (isWeb) {
    // ----- Web fallback -----
    let attempts = 0;
    while (attempts < retries) {
      try {
        // Clear previous
        if (webAudio) {
          webAudio.pause();
          webAudio.src = '';
          webAudio.load();
        }
        webAudio = new Audio(url);

        // Try to load
        await new Promise<void>((resolve, reject) => {
          if (!webAudio) return reject('Audio element missing');

          webAudio.oncanplaythrough = () => resolve();
          webAudio.onerror = e => {
            reject(e);
          };
        });

        // If we reach here, load was successful
        return true;
      } catch (e) {
        attempts++;
        if (attempts >= retries) {
          return false;
        }
        await sleep(1000);
      }
    }
    return false;
  } else {
    // ----- Native (Android/iOS) using TrackPlayer -----
    // let attempts = 0;
    // while (attempts < retries) {
    //   try {
    //     await TrackPlayer.reset();
    //     await TrackPlayer.add({url, id: url});
    //     const {state}: PlaybackState = await TrackPlayer.getPlaybackState();
    //     if (state === State.Error) {
    //       throw new Error('TrackPlayer in error state');
    //     }
    //     return true;
    //   } catch (e) {
    //     if (__DEV__) {
    //     }
    //     await TrackPlayer.reset();
    //     await sleep(1000);
    //     attempts++;
    //     if (attempts >= retries) {
    //       if (__DEV__) {
    //       }
    //       return false;
    //     }
    //   }
    // }
    return false;
  }
};

/**
 * Play the sound. If `url` is given and matches currently loaded track,
 * just play. Otherwise, load the new URL, then play.
 */
export const playSound = async (url?: string): Promise<boolean> => {
  if (isWeb) {
    // ----- Web fallback -----
    try {
      if (!url) {
        // If no URL provided, use the existing webAudio
        if (webAudio) {
          webAudio.currentTime = 0;
          await webAudio.play();
          return true;
        }
        return false;
      }

      // If there's an existing loaded URL and it matches
      if (webAudio && webAudio.src === url) {
        // Just play
        await webAudio.play();
        return true;
      }

      // Otherwise, load the new URL, then play
      const loaded = await loadSound(url);
      if (!loaded) return false;

      // Setup onended to mimic "queue ended"
      if (webAudio) {
        webAudio.onended = () => {
          webAudio?.pause();
          if (webAudio) webAudio.currentTime = 0;
        };
      }

      // Now play
      if (webAudio) {
        await webAudio.play();
        return true;
      }
    } catch (e) {
    }
    return false;
  } else {
    // ----- Native (Android/iOS) -----
    try {
      // let currentTrack: Track | undefined = {url: ''};
      // const currentTrackIndex = await TrackPlayer.getActiveTrackIndex();
      // if (currentTrackIndex != null) {
      //   currentTrack = await TrackPlayer.getTrack(currentTrackIndex);
      // }
      //
      // if (url && url === currentTrack?.url) {
      //   await TrackPlayer.play();
      //   return true;
      // }
      //
      // await loadSound(url || '');
      // await TrackPlayer.play();
      return true;
    } catch (e) {
      return false;
    }
  }
};

/**
 * Plays the user's "voice_url" from Redux store.
 */
export const playUserSound = async (): Promise<boolean> => {
  try {
    const {currentUser} = store.getState().auth || {};
    return await playSound(currentUser?.voice_url);
  } catch (e) {
    return false;
  }
};

/**
 * Pause the player.
 */
export const pausePlayer = async (): Promise<void> => {
  if (isWeb) {
    if (webAudio) {
      webAudio.pause();
    }
  } else {
    // await TrackPlayer.pause();
  }
};

/**
 * Stop/reset the player.
 * On web, pause & reset currentTime.
 */
export const stopPlayer = async (): Promise<void> => {
  if (isWeb) {
    if (webAudio) {
      webAudio.pause();
      webAudio.currentTime = 0;
      // If you want to completely unload, also do:
      webAudio.src = '';
      webAudio.load();
    }
  } else {
    // await TrackPlayer.reset();
  }
};
